<style scoped>
    .menu-c {
        display: flex;
        flex-direction: column;
        z-index: 20;
        background: white;
    }
    .search-c {
        padding: 10px;
    }
    .content-c {
        flex: 1;
        overflow: auto;
    }
    .content-item {
        padding: 10px 10px 0;
         cursor: pointer;
    }
        .content-item:hover {
        background: #eeeeee;
    }
</style>
<template>
  <v-menu
    ref="menu"
    content-class="menu-c"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-x
    top
    :max-height="contentHeigh"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="valueRender(my_value,item_hash[my_value] || null)"
        :label="text"
        :placeholder="placeholder"
        :required="required"
        :rules="rules"
        :prepend-icon="prependIcon"
        :disabled="disabled"
        readonly
        v-bind="attrs"
        v-on="on"
      >
        <template v-slot:append-outer>
          <slot name="append-outer" />
        </template>
      </v-text-field>
    </template>
    <div class="search-c">
      <v-text-field
        v-model="in_params[search_key]"
        :loading="getListLoading"
        append-icon="mdi-search-web"
        clearable
        @click:append="search"
      />
    </div>
    <div
      class="content-c"
    >
      <div
        v-for="(item,index) in list"
        :key="index"
        class="content-item"
        @click="()=>selectDate(item,index,list)"
      >
        <RenderContain 
          :render="(h)=>{
            return render(h,item,index,list)
          }"
        />
      </div>
    </div>
  </v-menu>
</template>
<script>
  const RenderContain = {
    props: {
      render: {
        type: Function,
      },
    },
    render(h) {
      return this.render(h)
    }
  } 
  export default {
    components: {RenderContain},
    props: {
      outList: {
        type: Array,
        default: () => []
      },
      value: {
        type: [String, Number]
      },
      valueKey: {
        type: String,
        default: () => 'id'
      },
      text: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
      required: {
        type: Boolean,
      },
      rules: {
        type: Array,
      },
      prependIcon: {
        type: String,
      },
      url: {
        type: String,
      },
      search_key: {
        type: String,
        default: () => 'search'
      },
      outParams: {
        type: Object,
        default: () => ({})
      },
      handleSearch: {
        type: Function
      },
      render: {
        type: Function,
      },
      contentHeigh: {
        type: Number,
        default:() => 250
      },
      valueRender: {
        type: Function,
      },
      disabled: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {
        menu: false,
        date: '',
        in_params: {
          [this.search_key]: '',
        },
        list: [],
        history_item_hash: {},
        getListLoading: false,
        my_value: this.value,
        item_hash_:{}
      }
    },
    computed: {
      item_hash() {
        const hash = {}
        const outList = this.outList || []
      
        outList.forEach(item => {
          const key = item[this.valueKey]
          hash[key] = item
        })
        return Object.assign(this.item_hash_, hash)
      },
    },
    watch: {
      my_value(val) {
        this.$emit('input', val)
      },
      value(val) {
        this.my_value = val
      }
    },
    methods: {
      search() {
        const params = {
          ...this.outParams,
          ...this.in_params,
        }
        this.getListLoading = true
        this.$emit('beforeSearch', params)
        this.$http.get(this.url, params).then(data => {
          this.$emit('afterSearch', data)
          this.list = this.handleSearch(data)
          this.list.forEach(item => {
            const key = item[this.valueKey]
            this.item_hash_[key] = item
          })
        }).finally(() => {
          this.getListLoading = false
        })
      },
      selectDate(item, index, list) {
        this.$refs.menu.save(item);
        this.my_value = item[this.valueKey]
        this.$emit('change', item, index, list);
      }
    }
  }
</script>
